class CartDrawer {
  constructor() {
    this.drawer = document.getElementById("cart-drawer");
    this.overlay = document.getElementById("cart-drawer-overlay");
    this.closeBtn = document.getElementById("cart-drawer-close");
    this.itemsContainer = document.getElementById("cart-drawer-items");
    this.emptyMessage = document.getElementById("cart-drawer-empty");
    this.footer = document.getElementById("cart-drawer-footer");
    this.subtotalElement = document.getElementById("cart-drawer-subtotal");

    this.quantityTimers = {};
    this.pendingQuantities = {};
    this.originalQuantities = {};
    this.itemPrices = {};

    this.init();
  }

  init() {
    const cartIcons = document.querySelectorAll(".hd_bag, .sp_cart");
    cartIcons.forEach((icon) => {
      icon.addEventListener("click", (e) => {
        e.preventDefault();
        this.open();
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", () => this.close());
    }

    if (this.overlay) {
      this.overlay.addEventListener("click", () => this.close());
    }

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.drawer.classList.contains("is-open")) {
        this.close();
      }
    });
  }

  async open() {
    this.drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";

    await this.fetchCart();
  }

  close() {
    // 保留中のリクエストをすべて即座に送信
    Object.keys(this.quantityTimers).forEach((key) => {
      clearTimeout(this.quantityTimers[key]);
      this.commitQuantityChange(key);
    });

    this.drawer.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  async fetchCart() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      this.updateCartDisplay(cart);
    } catch (error) {
      console.error("Error fetching cart:", error);
    }
  }

  updateCartDisplay(cart) {
    if (!cart || cart.item_count === 0) {
      this.emptyMessage.style.display = "block";
      this.itemsContainer.style.display = "none";
      this.footer.style.display = "none";
    } else {
      this.emptyMessage.style.display = "none";
      this.itemsContainer.style.display = "block";
      this.footer.style.display = "block";

      this.renderCartItems(cart.items);
      this.updateSubtotal(cart.total_price);
    }

    if (window.cartManager) {
      window.cartManager.updateCartCount();
    }
  }

  renderCartItems(items) {
    items.forEach((item) => {
      this.itemPrices[item.key] = item.price;
      this.originalQuantities[item.key] = item.quantity;
    });

    this.itemsContainer.innerHTML = items
      .map(
        (item) => `
      <div class="cart-drawer__item" data-key="${item.key}">
        <div class="cart-drawer__item-image">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" width="80" height="80">` : ""}
        </div>
        <div class="cart-drawer__item-details">
          <h3 class="cart-drawer__item-title">${item.product_title}</h3>
          ${item.variant_title ? `<p class="cart-drawer__item-variant">${item.variant_title}</p>` : ""}
          <div class="cart-drawer__item-price">
            <div class="cart-drawer__quantity-controls">
              <button class="quantity-btn quantity-btn--minus" data-key="${item.key}" aria-label="数量を減らす" ${item.quantity <= 1 ? "disabled" : ""}>−</button>
              <span class="quantity-value" data-key="${item.key}">${item.quantity}</span>
              <button class="quantity-btn quantity-btn--plus" data-key="${item.key}" aria-label="数量を増やす">＋</button>
            </div>
            <span class="cart-drawer__item-total" data-key="${item.key}">${this.formatMoney(item.line_price)}</span>
          </div>
        </div>
        <button class="cart-drawer__item-remove" data-key="${item.key}" aria-label="削除">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M12 4L4 12M4 4L12 12" stroke="#FF6683" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    `,
      )
      .join("");

    this.itemsContainer
      .querySelectorAll(".quantity-btn--minus")
      .forEach((btn) => {
        btn.addEventListener("click", async (e) => {
          const key = e.currentTarget.dataset.key;
          const currentQty = parseInt(
            this.itemsContainer.querySelector(
              `.quantity-value[data-key="${key}"]`,
            ).textContent,
          );
          await this.updateQuantity(key, currentQty - 1);
        });
      });

    this.itemsContainer
      .querySelectorAll(".quantity-btn--plus")
      .forEach((btn) => {
        btn.addEventListener("click", async (e) => {
          const key = e.currentTarget.dataset.key;
          const currentQty = parseInt(
            this.itemsContainer.querySelector(
              `.quantity-value[data-key="${key}"]`,
            ).textContent,
          );
          await this.updateQuantity(key, currentQty + 1);
        });
      });

    this.itemsContainer
      .querySelectorAll(".cart-drawer__item-remove")
      .forEach((btn) => {
        btn.addEventListener("click", (e) => {
          const key = e.currentTarget.dataset.key;
          this.removeItem(key);
        });
      });
  }

  async removeItem(key) {
    if (this.quantityTimers[key]) {
      clearTimeout(this.quantityTimers[key]);
      delete this.quantityTimers[key];
    }

    delete this.pendingQuantities[key];
    delete this.originalQuantities[key];
    delete this.itemPrices[key];

    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: key,
          quantity: 0,
        }),
      });

      const cart = await response.json();
      this.updateCartDisplay(cart);
    } catch (error) {
      console.error("Error removing item:", error);
    }
  }

  updateSubtotal(price) {
    this.subtotalElement.textContent = this.formatMoney(price);
  }

  formatMoney(cents) {
    return "¥" + (cents / 100).toLocaleString("ja-JP");
  }

  showToast(message, type = "info") {
    const container = document.getElementById("toast-container");
    if (!container) return;

    const toast = document.createElement("div");
    toast.className = `toast ${type}`;
    toast.textContent = message;

    container.appendChild(toast);

    setTimeout(() => {
      toast.classList.add("show");
    }, 10);

    setTimeout(() => {
      toast.classList.remove("show");
      setTimeout(() => {
        container.removeChild(toast);
      }, 300);
    }, 3000);
  }

  async updateQuantity(key, newQuantity) {
    if (newQuantity < 1) {
      return;
    }

    if (this.quantityTimers[key]) {
      clearTimeout(this.quantityTimers[key]);
    }

    this.pendingQuantities[key] = newQuantity;
    this.updateQuantityUI(key, newQuantity);

    // 500ms後にAPIリクエストを送信
    this.quantityTimers[key] = setTimeout(async () => {
      await this.commitQuantityChange(key);
    }, 500);
  }

  updateSingleItem(cart, key) {
    const item = cart.items.find((i) => i.key === key);
    if (!item) return;

    const quantityElement = this.itemsContainer.querySelector(
      `.quantity-value[data-key="${key}"]`,
    );
    if (quantityElement) {
      quantityElement.textContent = item.quantity;
    }

    const totalElement = this.itemsContainer.querySelector(
      `.cart-drawer__item-total[data-key="${key}"]`,
    );
    if (totalElement) {
      totalElement.textContent = this.formatMoney(item.line_price);
    }

    const minusButton = this.itemsContainer.querySelector(
      `.quantity-btn--minus[data-key="${key}"]`,
    );
    if (minusButton) {
      minusButton.disabled = item.quantity <= 1;
    }
  }

  updateQuantityUI(key, newQuantity) {
    const quantityElement = this.itemsContainer.querySelector(
      `.quantity-value[data-key="${key}"]`,
    );
    if (quantityElement) {
      quantityElement.textContent = newQuantity;
    }

    const unitPrice = this.itemPrices[key] || 0;
    const estimatedTotal = unitPrice * newQuantity;

    const totalElement = this.itemsContainer.querySelector(
      `.cart-drawer__item-total[data-key="${key}"]`,
    );
    if (totalElement) {
      totalElement.textContent = this.formatMoney(estimatedTotal);
    }

    const minusButton = this.itemsContainer.querySelector(
      `.quantity-btn--minus[data-key="${key}"]`,
    );
    if (minusButton) {
      minusButton.disabled = newQuantity <= 1;
    }

    this.updateEstimatedSubtotal();
  }

  updateEstimatedSubtotal() {
    let estimatedTotal = 0;

    Object.keys(this.itemPrices).forEach((key) => {
      const quantity =
        this.pendingQuantities[key] || this.originalQuantities[key];
      const unitPrice = this.itemPrices[key];
      estimatedTotal += unitPrice * quantity;
    });

    this.subtotalElement.textContent = this.formatMoney(estimatedTotal);
  }

  async commitQuantityChange(key) {
    const newQuantity = this.pendingQuantities[key];

    try {
      this.disableQuantityButtons(key);

      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: key,
          quantity: newQuantity,
        }),
      });

      const cart = await response.json();

      if (response.status === 422) {
        this.rollbackQuantity(key);
        this.showToast(cart.description || "数量の変更に失敗しました", "error");
        this.enableQuantityButtons(key);
        return;
      }

      this.updateSingleItem(cart, key);
      this.updateSubtotal(cart.total_price);

      // 元の数量を更新
      this.originalQuantities[key] = newQuantity;

      // カートバッジ更新
      if (window.cartManager) {
        window.cartManager.updateCartCount();
      }

      this.showToast("カートを更新しました", "success");
      this.enableQuantityButtons(key);

      delete this.quantityTimers[key];
      delete this.pendingQuantities[key];
    } catch (error) {
      console.error("Error updating quantity:", error);
      this.rollbackQuantity(key);
      this.showToast("数量の変更に失敗しました", "error");
      this.enableQuantityButtons(key);
    }
  }

  rollbackQuantity(key) {
    const originalQty = this.originalQuantities[key];
    if (!originalQty) return;

    this.updateQuantityUI(key, originalQty);

    delete this.pendingQuantities[key];
    delete this.quantityTimers[key];
  }

  disableQuantityButtons(key) {
    const buttons = this.itemsContainer.querySelectorAll(
      `.quantity-btn[data-key="${key}"]`,
    );
    buttons.forEach((btn) => {
      btn.disabled = true;
    });
  }

  enableQuantityButtons(key) {
    const plusButton = this.itemsContainer.querySelector(
      `.quantity-btn--plus[data-key="${key}"]`,
    );
    if (plusButton) {
      plusButton.disabled = false;
    }

    const minusButton = this.itemsContainer.querySelector(
      `.quantity-btn--minus[data-key="${key}"]`,
    );
    const quantityElement = this.itemsContainer.querySelector(
      `.quantity-value[data-key="${key}"]`,
    );
    if (minusButton && quantityElement) {
      const currentQty = parseInt(quantityElement.textContent);
      minusButton.disabled = currentQty <= 1;
    }
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    window.cartDrawerInstance = new CartDrawer();
  });
} else {
  window.cartDrawerInstance = new CartDrawer();
}
